/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The OperationalScopeDTO model module.
 * @module model/OperationalScopeDTO
 * @version v0
 */
export class OperationalScopeDTO {
  /**
   * Constructs a new <code>OperationalScopeDTO</code>.
   * @alias module:model/OperationalScopeDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OperationalScopeDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OperationalScopeDTO} obj Optional instance to populate.
   * @return {module:model/OperationalScopeDTO} The populated <code>OperationalScopeDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OperationalScopeDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('deletable'))
        obj.deletable = ApiClient.convertToType(data['deletable'], 'Boolean');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
OperationalScopeDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
OperationalScopeDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
OperationalScopeDTO.prototype.active = undefined;

/**
 * @member {Boolean} deletable
 */
OperationalScopeDTO.prototype.deletable = undefined;

/**
 * @member {Number} position
 */
OperationalScopeDTO.prototype.position = undefined;

/**
 * @member {String} tooltip
 */
OperationalScopeDTO.prototype.tooltip = undefined;

